import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { capitalize } from "lodash";
import { cn as clsx } from "../../helpers/react.js";
import '../../assets/index13.css';const workSansHeading40 = "_workSansHeading40_dbzvh_1";
const workSansHeading32 = "_workSansHeading32_dbzvh_10";
const workSansHeading28 = "_workSansHeading28_dbzvh_19";
const workSansHeading24 = "_workSansHeading24_dbzvh_28";
const workSansHeading20 = "_workSansHeading20_dbzvh_37";
const workSansHeading16 = "_workSansHeading16_dbzvh_46";
const workSans20Regular = "_workSans20Regular_dbzvh_55";
const workSans20Medium = "_workSans20Medium_dbzvh_64";
const workSans16Regular = "_workSans16Regular_dbzvh_73";
const workSans16Medium = "_workSans16Medium_dbzvh_82";
const workSans16Semibold = "_workSans16Semibold_dbzvh_91";
const workSans14Regular = "_workSans14Regular_dbzvh_100";
const workSans14Medium = "_workSans14Medium_dbzvh_109";
const workSans14Semibold = "_workSans14Semibold_dbzvh_118";
const workSans13Medium = "_workSans13Medium_dbzvh_127";
const workSans13Semibold = "_workSans13Semibold_dbzvh_136";
const workSans12Regular = "_workSans12Regular_dbzvh_145";
const workSans12Medium = "_workSans12Medium_dbzvh_154";
const workSans12Semibold = "_workSans12Semibold_dbzvh_163";
const workSans10Regular = "_workSans10Regular_dbzvh_172";
const workSans10Medium = "_workSans10Medium_dbzvh_181";
const workSansUppercase14Regular = "_workSansUppercase14Regular_dbzvh_190";
const workSansUppercase14Medium = "_workSansUppercase14Medium_dbzvh_200";
const workSansUppercase12Medium = "_workSansUppercase12Medium_dbzvh_210";
const workSansUppercase12Semibold = "_workSansUppercase12Semibold_dbzvh_220";
const workSansUppercase9Semibold = "_workSansUppercase9Semibold_dbzvh_230";
const nkduyMonoNumerical32Medium = "_nkduyMonoNumerical32Medium_dbzvh_240";
const nkduyMonoNumerical24Regular = "_nkduyMonoNumerical24Regular_dbzvh_250";
const nkduyMonoNumerical20Regular = "_nkduyMonoNumerical20Regular_dbzvh_260";
const nkduyMonoNumerical16Regular = "_nkduyMonoNumerical16Regular_dbzvh_270";
const nkduyMonoNumerical16Medium = "_nkduyMonoNumerical16Medium_dbzvh_280";
const nkduyMonoNumerical16Bold = "_nkduyMonoNumerical16Bold_dbzvh_290";
const nkduyMonoNumerical14Medium = "_nkduyMonoNumerical14Medium_dbzvh_300";
const nkduyMonoNumerical14Semibold = "_nkduyMonoNumerical14Semibold_dbzvh_310";
const nkduyMonoNumerical14Bold = "_nkduyMonoNumerical14Bold_dbzvh_320";
const nkduyMonoNumerical13Medium = "_nkduyMonoNumerical13Medium_dbzvh_330";
const nkduyMonoNumerical13Semibold = "_nkduyMonoNumerical13Semibold_dbzvh_340";
const nkduyMonoNumerical13Bold = "_nkduyMonoNumerical13Bold_dbzvh_350";
const nkduyMonoNumerical12Semibold = "_nkduyMonoNumerical12Semibold_dbzvh_360";
const nkduyMonoNumerical12Bold = "_nkduyMonoNumerical12Bold_dbzvh_370";
const nkduyMonoNumerical10Bold = "_nkduyMonoNumerical10Bold_dbzvh_380";
const s = {
  workSansHeading40,
  workSansHeading32,
  workSansHeading28,
  workSansHeading24,
  workSansHeading20,
  workSansHeading16,
  workSans20Regular,
  workSans20Medium,
  workSans16Regular,
  workSans16Medium,
  workSans16Semibold,
  workSans14Regular,
  workSans14Medium,
  workSans14Semibold,
  workSans13Medium,
  workSans13Semibold,
  workSans12Regular,
  workSans12Medium,
  workSans12Semibold,
  workSans10Regular,
  workSans10Medium,
  workSansUppercase14Regular,
  workSansUppercase14Medium,
  workSansUppercase12Medium,
  workSansUppercase12Semibold,
  workSansUppercase9Semibold,
  nkduyMonoNumerical32Medium,
  nkduyMonoNumerical24Regular,
  nkduyMonoNumerical20Regular,
  nkduyMonoNumerical16Regular,
  nkduyMonoNumerical16Medium,
  nkduyMonoNumerical16Bold,
  nkduyMonoNumerical14Medium,
  nkduyMonoNumerical14Semibold,
  nkduyMonoNumerical14Bold,
  nkduyMonoNumerical13Medium,
  nkduyMonoNumerical13Semibold,
  nkduyMonoNumerical13Bold,
  nkduyMonoNumerical12Semibold,
  nkduyMonoNumerical12Bold,
  nkduyMonoNumerical10Bold
};
const getFontClassName = (props) => {
  let key = "";
  switch (props.type) {
    case "heading":
      key = `workSansHeading${props.size.toString()}`;
      break;
    case "numerical":
      key = `nkduyMonoNumerical${props.size}${capitalize(props.weight)}`;
      break;
    case "text":
      key = `workSans${props.size}${capitalize(props.weight)}`;
      break;
    case "uppercase":
      key = `workSansUppercase${props.size}${capitalize(props.weight)}`;
      break;
  }
  if (!s[key]) {
    console.warn("Not font style for " + key);
    return null;
  }
  return s[key];
};
const Font = forwardRef((props, ref) => {
  const { children } = props;
  return /* @__PURE__ */ jsx(Slot, { ref, className: clsx(getFontClassName(props)), children });
});
export {
  Font
};
